import { NgTemplateOutlet } from '@angular/common';
import type { TemplateRef } from '@angular/core';
import { Component, input, output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import { ClipboardCopy, IconButtonComponent, RtTooltip } from '@recruitee/user-interface';

export type CandidateFieldRow = {
  value: string;
  isValid?: boolean;
};

@Component({
  selector: 'rt-candidate-field-row',
  imports: [IconButtonComponent, TranslatePipe, RtTooltip, NgTemplateOutlet],
  templateUrl: './candidate-field-row.component.html',
  styleUrl: './candidate-field-row.component.less',
})
export class CandidateFieldRowComponent {
  public name = input.required<string>();
  public copyable = input<boolean>(false);
  public editable = input<boolean>(false);
  public editing = input<boolean>(false);
  public displayInline = input<boolean>(false);
  public field = input<CandidateFieldRow[] | null>();
  public fieldDisplayTpl = input<TemplateRef<any>>();
  public fieldEditTpl = input<TemplateRef<any>>();
  public tooltipEnabled = input<boolean>(false);
  public tooltipText = input<string>();

  public edit = output<void>();

  constructor(private clipboardCopy: ClipboardCopy) {}

  public copyToClipboard(value: string): void {
    this.clipboardCopy.fromString(value);
  }
}
